<form
	[formGroup]="formGroup"
	[ngClass]="{'mt-5': addSpaceToPrevious}"
>
	<div
		class="row mb-3 formElementWrapper"
		[ngClass]="baseCssClass"
		(mouseover)="setHovered( true )"
		(mouseout)="setHovered( false )"
	>

		<!-- Label -->
		<ng-container *ngIf="!config.hideLabel">
			<app-label
				formEntityId="{{formEntityIdOverwrite ? formEntityIdOverwrite : formEntityId}}"
				labelText="{{ labelText ? labelText : getI18nString(false, translationPath + '.label') }}"
				[formControlInline]="formControlInline"
				[labelClassObject]="{
					'hovered': isHovered,
					'focused': hasFocus,
					'error': control?.errors && !hideErrors
				}"
				[labelHostClassString]="labelHostClassString"
				[labelInfoInline]="labelInfoInline"
				[required]="isRequired"
				[requiredByElster]="config.elsterRequiredField"
				[showElsterIndicator]="config.elsterShowIndicator"
			></app-label>
		</ng-container>

		<!-- Input Block -->
		<div
			class="inputBlockWrapper col-12"
			[ngClass]="{'col-md-8' : formControlInline}"
		>

			<div
				class="col-{{colSpan}} px-0 {{ inputWrapperStyleClass }}"
				[ngClass]="{'row mx-0': hasInputAppendedContent }"
			>
				<!-- Input Wrapper -->
				<ng-container [ngSwitch]="inputType">
					<app-input-number
						*ngSwitchCase="'number'"
						class="d-block"
						formControlName="{{formControlNameOverwrite ? formControlNameOverwrite : formEntityId}}"
						[disabled]="disableControl"
						[hasError]="control?.errors && !hideErrors"
						[id]="formEntityIdOverwrite ? formEntityIdOverwrite : formEntityId"
						[inputStyleClass]="'form-control'"
						[inputWrapperStyleClass]="inputWrapperStyleClass"
						[isHovered]="isHovered"
						[isFocused]="hasFocus"
						[minNumber]="minNumber"
						[maxNumber]="maxNumber"
						[placeholder]="config.hidePlaceholder ? null : getI18nString(false,translationPath + '.placeholder')"
						[readOnly]="readOnly || disableControl"
						[tabindex]="+config.tabindex"
					></app-input-number>

				<div
					*ngSwitchDefault
					class="inputWrapper mb-1 {{ inputWrapperStyleClass }}"
					[ngClass]="{
						'controlDisabled': disableControl,
						'hovered': isHovered,
						'focused': hasFocus,
						'error': control?.errors && !hideErrors
				 	}">

					<!-- Input Group -->
					<div class="d-flex px-2">

						<!-- Input -->
						<input
							class="form-control"
							[appDisableControl]="{condition: disableControl, control: control}"
							[attr.data-e2e]="formEntityId + '-input'"
							[attr.min]="minNumber"
							[attr.max]="maxNumber"
							[readOnly]="readOnly || disableControl"
							tabindex="{{config.tabindex}}"
							id="{{formEntityIdOverwrite ? formEntityIdOverwrite : formEntityId}}"
							type="{{ inputType }}"
							placeholder="{{ config.hidePlaceholder ? null : getI18nString(false,translationPath + '.placeholder') }}"
							formControlName="{{formControlNameOverwrite ? formControlNameOverwrite : formEntityId}}"
							appFormControlTrim
							(blur)="onBlurEvent()"
							(focusin)="setFocus( true )"
							(focusout)="setFocus( false )"
						>

						<!-- Actions -->
						<div class="d-flex input-actions">

							<!-- Clear Button -->
							<div *ngIf="showClearButton && !disableControl">
								<i class="input-group-text ft-x" (click)="clearControlValue()"></i>
							</div>

							<!-- Revert Button -->
							<div *ngIf="showRevertButton && !disableControl">
								<i class="input-group-text icon-action-undo" (click)="revertControlValue()"></i>
							</div>

							<!-- Toggle Password Visibility Button-->
							<div *ngIf="config.type === 'password' && control.value">
								<i
									class="input-group-text"
									[ngClass]="showPassword ? 'ft-eye' : 'ft-eye-off'"
									(click)="togglePassword()"
								></i>
							</div>
						</div>
					</div>
				</div>
				</ng-container>

				<ng-container *ngIf="hasInputAppendedContent">
					<ng-content></ng-content>
				</ng-container>

				<!-- Error -->
				<app-error
					[control]="control"
					[hideErrors]="hideErrors || hideErrorDescriptions"
					[errorMsg]="errorMsg"
				></app-error>
			</div>

			<!-- Input Information -->
			<app-info
				[baseClass]="'col-12 mb-3 mt-2 px-0'"
				[hideInfoIcon]="true"
				[infoText]="getI18nString( false, translationPath + '.info' )"
			></app-info>
		</div>
	</div>
</form>
